/**
 * Projects-related Redux Actions
 */
/* tslint:disable:max-line-length */
import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('Projects');

export const setProjects = actionCreator<ISetProjectsActionPayload>('SET_PROJECTS');
// export const addTrackToProject = actionCreator<IAddTrackToProjectActionPayload>('ADD_TRACK_TO_PROJECT');

// Request Async Actions
export const requestCreateProject = actionCreator<IRequestCreateProjectActionPayload>('REQUEST_CREATE_PROJECT');
export const requestUpdateProject = actionCreator<IRequestUpdateProjectActionPayload>('REQUEST_UPDATE_PROJECT');
export const requestJoinProject = actionCreator<IRequestJoinProjectActionPayload>('REQUEST_JOIN_PROJECT');
export const requestDeleteProject = actionCreator<IRequestDeleteProjectActionPayload>('REQUEST_DELETE_PROJECT');
export const requestAddTrackToProject = actionCreator<IRequestAddTrackToProjectActionPayload>('REQUEST_ADD_TRACK_TO_PROJECT');

// Async Actions
export const createProject = actionCreator.async<ICreateProjectActionPayload, IMutationResult, Error>('CREATE_PROJECT');
export const updateProject = actionCreator.async<IUpdateProjectActionPayload, IMutationResult, Error>('UPDATE_PROJECT');
export const joinProject = actionCreator.async<IJoinProjectActionPayload, IMutationResult, Error>('JOIN_PROJECT');
export const deleteProject = actionCreator.async<IDeleteProjectActionPayload, IMutationResult, Error>('DELETE_PROJECT');
export const addTrackToProject = actionCreator.async<IAddTrackToProjectActionPayload, IMutationResult, Error>('ADD_TRACK_TO_PROJECT');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/projects.ts